import React from 'react'
import { HomeSection } from '../../index'

function HomeSectionDoubled({ imageCs_1, titleHl_1, textHl_1, bgColor_1, hidden_1, imageCs_2, titleHl_2, textHl_2, bgColor_2, hidden_2, ctasV2 }) {
  const showSection1 = !hidden_1
  const showSection2 = !hidden_2

  if (!showSection1 && !showSection2) {
    return null
  }

  return (
    <div className="flex lg:flex-row flex-col gap-4">
      {showSection1 && (
        <div className="w-full">
          <HomeSection imageCs={imageCs_1} titleHl={titleHl_1} textHl={textHl_1} ctasV2={ctasV2?.slice(0, 2) || []} margin={'8px 0 16px 16px'} marginMobile={'8px 16px 0px 16px'} bgColor={bgColor_1}/>
        </div>
      )}
      {showSection2 && (
        <div className="w-full">
          <HomeSection imageCs={imageCs_2} titleHl={titleHl_2} textHl={textHl_2} ctasV2={ctasV2?.slice(2, 4) || []} margin={'8px 16px 16px 0'} marginMobile={'0px 16px 0px 16px'} bgColor={bgColor_2}/>
        </div>
      )}
    </div>
  )
}

export default HomeSectionDoubled
